'use strict';

angular.module('impactx.dropzone', []);